import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { SummaryBox } from './Information.styles';

type Props = {
    children: ReactNode;
};

const Information = ({ children }: Props) => {
    return <Box sx={SummaryBox}>{children}</Box>;
};

export default Information;
